"use strict"
exports.__esModule = true;
exports.MagnetIconConfig = {
  name: 'MagnetIcon',
  height: 512,
  width: 512,
  svgPath: 'M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z',
  yOffset: 0,
  xOffset: 0,
};
exports.MagnetIcon = require('../createIcon').createIcon(exports.MagnetIconConfig);
exports["default"] = exports.MagnetIcon;